
import {useDispatch, useSelector} from "react-redux";
import { RootState } from "../../Store";
import Style from "./Style.module.scss";
import { SpeedAction} from "../state/speed";
import {useCallback, useRef, useState} from "react";
import Overlay from "react-bootstrap/Overlay";
import { ClickOuterDiv} from "../../Hook/useClickOuter";
import rectanglesvg from "../../../static/rectangle.svg";

export const Rychlost = () => {

    const [selected, setSelected] = useState(0);
    const buttonRef = useRef<HTMLButtonElement|null>(null);
    const dispatch = useDispatch();
    const speed = useSelector((app:RootState) => app.speed);

    const onHide = useCallback(() =>{
        setSelected(c => {
            c--;
            if (c < 0)
                return 0;
            return c;
        });
    },[]);

    return <div className={`align-self-center me-24px`}>
        <button className={`${Style.Button} ${Style.Speed}`} ref={buttonRef} onClick={e=>{
        if (selected) {
            setSelected(0);
        }
        else {
            setSelected(2);
        }
    }}>
        {speed}x
        </button>
        <Overlay target={buttonRef.current} show={!!selected} placement={"top"}>
            {({
                  placement: _placement,
                  arrowProps: _arrowProps,
                  show: _show,
                  popper: _popper,
                  hasDoneInitialMeasure: _hasDoneInitialMeasure,
                  ...props
              }) => (
                <div
                    key={"own"}
                    {...props}
                    style={{
                        position: 'absolute',
                        zIndex:150,
                        padding: '10px 10px',
                        borderRadius: 10,
                        ...props.style,
                        transform: (props.style.transform ?? "") + " translate(0, -50px)"
                    }}
                    className={`${Style.MenuBackground} ${Style.menu}`}
                >
                    <ClickOuterDiv onOutClick={onHide}>
                        <ul className={Style.subMenu}>
                            {[0.5, .75, 1, 1.25, 1.50, 1.75, 2].map(x => <li key={x}><a href={"#speed"} onClick={e=>{
                                e.preventDefault();
                                setSelected(0);
                                dispatch<SpeedAction>({
                                    type: "Speed",
                                    payload: x
                                })
                            }}>{x.toFixed(2)}</a></li> )}
                        </ul>
                    </ClickOuterDiv>
                    <img src={rectanglesvg} alt={""} className={Style.Rectangle} />
                </div>
            )}
        </Overlay>
    </div>
}